import { useAddinData } from "../addins/useAddinData";
import AddInIds from "@/constants/AddInIds";
import { Preset } from "@/models/Preset";

export default function usePresets() {
  const { data: presets = [], ...rest } = useAddinData<Preset>(AddInIds.presets);

  return {
    data: presets.map(
      addin =>
        ({
          ...addin,
          id: addin.id,
        }) as Preset,
    ),
    ...rest,
  };
}
